import { API_BASE_URL } from "@/config";
import { useToast } from '@/components/Toast/useToast';

export default {
    name: 'EnterpriseAntiMoneyLaunderingForm',
    setup() {
        const { showSuccess, showError } = useToast();
        
        return {
            showSuccess,
            showError
        };
    },
    data() {
        return {
            form: {
                enterprise_name: '',
            }
        };
    },
    emits: ['service_status_complete'],
    methods: {
        handle_submit() {
            if (!this.form.enterprise_name) {
                this.showError('Error', 'All fields are required.');
                return;
            }

            const string_fields = ['enterprise_name'];
            for (const field of string_fields) {
                if (typeof this.form[field] !== 'string' || !this.form[field].trim()) {
                    this.showError('Error', `Invalid input for ${field.replace('_', ' ')}. Please enter a valid string.`);
                    return;
                }
            }

            const TOKEN = localStorage.getItem('token');
            const ENTERPRISE_ANTI_MONEY_LAUNDERING_API = `${API_BASE_URL}/verify_api/instant_verify_api/enterprise_anti_money_laundering/`;

            this.error = '';

            $.ajax({
                url: ENTERPRISE_ANTI_MONEY_LAUNDERING_API,
                method: 'POST',
                contentType: 'application/json',
                headers: {
                    Authorization: `Token ${TOKEN}`
                },
                data: JSON.stringify({
                    enterprise_name: this.form.enterprise_name,
                }),
                beforeSend: () => {
                    Swal.fire({
                        text: 'Loading ...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => Swal.showLoading(),
                    });
                },
                success: () => {
                    Swal.close();
                    this.showSuccess('Successful', 'Enterprise AML Check ran successfully', 3000);
                    this.$emit('service_status_complete');
                    this.form.enterprise_name = '';
                },
                error: (error) => {
                    Swal.close();
                    let error_message = 'Something went wrong!';

                    if (error.responseJSON && error.responseJSON.message) {
                        error_message = error.responseJSON.message;
                    }

                    this.showError('Error', error_message);
                }
            });
        },
    }
};
